<p-toast></p-toast>
<app-nav-header></app-nav-header>
<div class="wrapper">
	<div class="main">
		<div id="recruitPage">
			<div
				*ngIf="mode === 'list'"
				class="formArea"
			>
				<div class="formAreaBox">
					<div class="formBox">
						<div class="personBox">
							<div class="titleBox">
								<p>會員註冊</p>
							</div>
							<form
								[formGroup]="buyerForm"
								class="row justify-content-center"
							>
								<div class="form-group d-flex col-12 col-md-8 align-items-center mb-1">
									<label
										class="mb-0"
										style="flex: 1 2.6rem"
									>
										<span>帳號</span>
									</label>
									<div
										class="col pr-0 field-cus"
										style="flex: 7"
									>
										<input
											pInputText
											type="text"
											placeholder="請輸入您的電子郵件"
											formControlName="email"
											id="email"
										/>
									</div>
								</div>
								<div class="form-group d-flex col-12 col-md-8 align-items-center mb-1">
									<label
										class="mb-0"
										style="flex: 1 2.6rem"
									>
										<span>密碼</span>
									</label>
									<div
										class="col pr-0 field-cus"
										style="flex: 7"
									>
										<div class="d-flex">
											<input
												pInputText
												type="password"
												placeholder="請輸入密碼"
												formControlName="pwd"
												id="pwd"
											/>
										</div>
									</div>
								</div>
								<div class="form-group d-flex col-12 col-md-8 align-items-center mb-1">
									<label
										class="mb-0"
										style="flex: 1 2.6rem"
									>
										<span>姓名</span>
									</label>
									<div
										class="col pr-0 field-cus"
										style="flex: 7"
									>
										<input
											pInputText
											type="text"
											placeholder="請輸入本名"
											formControlName="name"
											id="name"
										/>
									</div>
								</div>
								<div class="form-group d-flex col-12 col-md-8 align-items-center mb-1">
									<label
										class="mb-0"
										style="flex: 1 2.6rem"
									>
										<span>團拆暱稱</span>
									</label>
									<div
										class="col pr-0 field-cus"
										style="flex: 7"
									>
										<input
											pInputText
											type="text"
											placeholder="未填即使用本名"
											formControlName="nickName"
											id="nickName"
										/>
									</div>
								</div>
								<div class="form-group d-flex col-12 col-md-8 align-items-center mb-1">
									<label
										class="mb-0"
										style="flex: 1 2.6rem"
									>
										<span>手機號碼</span>
									</label>
									<div
										class="col pr-0 field-cus"
										style="flex: 7"
									>
										<input
											pInputText
											type="text"
											placeholder="務必輸入正確"
											formControlName="phone"
											id="phone"
										/>
									</div>
								</div>
								<div class="form-group d-flex col-12 col-md-8 align-items-center mb-1">
									<label
										class="mb-0"
										style="flex: 1 2.6rem"
									>
										<span>匯款帳號</span>
									</label>
									<div
										class="col pr-0 field-cus"
										style="flex: 7"
									>
										<input
											pInputText
											type="text"
											placeholder="輸入末5碼即可"
											formControlName="bankAccount"
											id="bankAccount"
										/>
									</div>
								</div>
								<div class="form-group d-flex col-12 col-md-8 align-items-center mb-1">
									<label
										class="mb-0"
										style="flex: 1 2.6rem"
									>
										<span>711門市</span>
									</label>
									<div
										class="col pr-0 field-cus"
										style="flex: 7"
									>
										<input
											pInputText
											type="text"
											placeholder="輸入收件711門市"
											formControlName="711Name"
											id="711Name"
										/>
									</div>
								</div>
							</form>
							<div style="flex: 2">
								<div class="footerBox">
									<button
										class="vacancies-btn"
										(click)="register()"
									>
										<span>註冊</span>
									</button>
								</div>
							</div>
							<!-- <span
								(click)="op.toggle($event)"
								style="
									cursor: pointer;
									text-decoration: underline;
									padding-left: 1rem;
									align-self: center;
								"
							>
								點擊查看支架尺寸(10元/個)
							</span> -->
						</div>
					</div>
				</div>
			</div>

			<div
				*ngIf="mode === 'success'"
				class="detailArea"
				style="padding-top: 20vh !important"
			>
				<div class="detailAreaBox">
					<div class="titleBox">
						<p>訂購成功！！</p>
						<p>看到這個畫面即可進行匯款</p>
						<p>匯款資訊：(台新銀行)812-28881022569059</p>
						<p>{{ '總金額：$' + calcTotalTeamsCost(selectedTeamsList) }}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<p-overlayPanel #op>
	<img
		src="/bigaunt/assets/images/display-card.png"
		alt="Big Aunt's"
		class="random-notice"
	/>
	<!-- <b>📍玩法規則｜Lucky Wheel 幸運轉盤</b>
	<br />
	<b>ㄧ、每開一張卡，立即使用隨機轉盤轉出該卡得主</b>
	<br />
	<b>二、其中16人，每人將獲得 1 張卡片。</b>
	<br />
	<br />
	<b style="background-color: #f5fa44">*空門Bonus</b>
	<br />
	<b style="background-color: #f5fa44">4位空門者中，將隨機轉盤抽出 1 位獲得2024-25 Mosaic Blaster*1</b>
	<br /> -->
</p-overlayPanel>
